<template>
    <div class="w-full h-full py-5">
        <template v-if="loading">
            <div>
                Loading...
            </div>
        </template>
        <template v-else>
            <div class="font-bold text-2xl mb-1">
                <div class="inline-flex align-middle">
                    Chi tiết lộ trình
                </div>
                <div class="inline-flex align-middle items-center ml-2 gap-2">
                    <!--
                      <alert-status
                      :status="journey.processAlertStatus"
                      size="large" />
                    -->
                    <div v-if="waitingTime">
                        <hts-tooltip>
                            <template #reference>
                                <hts-icons
                                    icon-name="hi-clock-icon"
                                    size="large"
                                    color="orange" />
                            </template>
                            <div>
                                Tổng thời gian chờ: {{ $formatters.duration(waitingTime, 'second') }} - {{ waitingTime }}
                            </div>
                        </hts-tooltip>
                    </div>
                </div>
            </div>
            <div class="flex justify-end">
                <div class="block space-x-1">
                    <div class="inline-flex flex-col">
                        <div class="block">
                            <span
                                class="hts-journey-info__stage-description"
                                alert="green" />
                            <span class="inline-block align-middle">
                                Điểm không có cảnh báo
                            </span>
                        </div>
                        <div class="block">
                            <span
                                class="hts-journey-info__task-description"
                                alert="green" />
                            <span class="inline-block align-middle">
                                Tác vụ không có cảnh báo
                            </span>
                        </div>
                    </div>
                    <div class="inline-flex flex-col">
                        <div class="block">
                            <span
                                class="hts-journey-info__stage-description"
                                alert="yellow" />
                            <span class="inline-block">
                                Điểm cảnh báo vàng
                            </span>
                        </div>
                        <div class="block">
                            <span
                                class="hts-journey-info__task-description"
                                alert="yellow" />
                            <span class="inline-block align-middle">
                                Tác vụ cảnh báo vàng
                            </span>
                        </div>
                    </div>
                    <div class="inline-flex flex-col">
                        <div class="block">
                            <span
                                class="hts-journey-info__stage-description"
                                alert="red" />
                            <span class="inline-block align-middle">
                                Điểm cảnh báo đỏ
                            </span>
                        </div>
                        <div class="block">
                            <span
                                class="hts-journey-info__task-description"
                                alert="red" />
                            <span class="inline-block align-middle">
                                Tác vụ cảnh báo đỏ
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-full w-full flex relative">
                <div
                    style="width: 100px"
                    class="h-full px-2">
                    <div
                        :style="{ height: config.unitHeight * 4 + 'px' }"
                        class="block font-bold">
                        <div
                            class="flex items-center justify-end w-full"
                            :style="{ height: config.unitHeight * 2 + 'px' }">
                            {{ scaler === 'day' ? 'Ngày' : scaler === 'month' ? 'Tháng' : 'Ngày - Giờ' }}
                        </div>
                        <div
                            class="flex items-center justify-end w-full"
                            :style="{ height: config.unitHeight * 2 + 'px' }">
                            {{ scaler === 'day' ? 'Giờ' : scaler === 'month' ? 'Ngày' : 'Phút' }}
                        </div>
                    </div>
                    <div
                        :style="{ height: config.unitHeight * 4 + 'px' }"
                        class="flex items-center font-medium justify-end">
                        <span>
                            Tối ưu
                        </span>
                    </div>
                    <div
                        :style="{ height: config.unitHeight * 4 + 'px' }"
                        class="flex items-center font-medium justify-end">
                        Thực tế
                    </div>
                </div>
                <div class="flex-1 overflow-auto relative border-l">
                    <div
                        class="relative"
                        :style="{ width: timelineWidth + 'px', height: config.unitHeight * 4 + 'px' }">
                        <template
                            v-for="(day, index) in ranges"
                            :key="index">
                            <div
                                class="relative inline-block text-center border-r border-b border-t"
                                :style="{ height: config.unitHeight * 4 + 'px', width: config.unitWidth * (scaler === 'day' ? day.units : rangeUnits) + 'px' }">
                                <div
                                    class="w-full flex items-center justify-center font-medium select-none"
                                    :class="{ 'cursor-pointer': ['day', 'hour'].includes(scaler) }"
                                    :style="{ height: config.unitHeight * 2 + 'px' }"
                                    @click="setScaler(day, scaler === 'day' ? 'month' : 'day')">
                                    {{ day.label }}
                                </div>
                                <template v-if="scaler === 'day'">
                                    <template
                                        v-for="u in day.units"
                                        :key="u">
                                        <div
                                            class="absolute border-r border-t text-sm flex items-center justify-center select-none"
                                            :class="{ 'cursor-pointer': ['month', 'day'].includes(scaler) }"
                                            :style="{
                                                left: (u - 1) * config.unitWidth + 'px',
                                                top: config.unitHeight * 2 + 'px',
                                                height: config.unitHeight * 2 + 'px',
                                                width: config.unitWidth + 'px'
                                            }"
                                            @click="setSubScaler(day, 'hour', u + day.min - 1)">
                                            {{ (u + day.min - 1).toString().padStart(2, '0') }}
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <template
                                        v-for="u in rangeUnits"
                                        :key="u">
                                        <div
                                            v-if="u > day.min"
                                            class="absolute border-r border-t text-sm flex items-center justify-center select-none"
                                            :class="{ 'cursor-pointer': ['month', 'day'].includes(scaler) }"
                                            :style="{
                                                left: (u - day.min - 1) * config.unitWidth + 'px',
                                                top: config.unitHeight * 2 + 'px',
                                                height: config.unitHeight * 2 + 'px',
                                                width: config.unitWidth + 'px'
                                            }"
                                            @click="setSubScaler(day, scaler === 'month' ? 'day' : 'hour', u - (scaler === 'month' ? 0 : 1))">
                                            {{ (u - (scaler === 'month' ? 0 : 1)).toString().padStart(2, '0') }}{{ scaler === 'day' ? ':00' : '' }}
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </template>
                    </div>
                    <div
                        class="relative overflow-hidden"
                        :style="{ width: timelineWidth + 'px' }">
                        <div class="relative py-1 hover:bg-gray-100">
                            <div
                                class="relative"
                                :style="{ height: config.unitHeight * 4 + 'px' }">
                                <hts-tooltip
                                    v-if="!exclude.includes('start')"
                                    class="hts-journey-info-travel__start"
                                    :style="getStartStyle()">
                                    <template #reference>
                                        <span>
                                            start
                                        </span>
                                    </template>
                                    <p class="text-blue-500 font-medium">
                                        Khởi hành: {{ journeyStartAt }}
                                    </p>
                                    <p
                                        v-if="journey.startAtParking"
                                        class="text-green-500 font-medium">
                                        Khởi hành tại bãi
                                    </p>
                                    <p>
                                        Địa điểm khởi hành: {{ journey.startAtLocation?.address }}
                                    </p>
                                </hts-tooltip>
                                <hts-tooltip
                                    v-if="!exclude.includes('stop')"
                                    class="hts-journey-info-travel__stop"
                                    :style="getStopStyle()">
                                    <template #reference>
                                        <span>
                                            stop
                                        </span>
                                    </template>
                                    <p class="text-blue-500 font-medium">
                                        Kết thúc: {{ journeyStopAt }}
                                    </p>
                                    <p
                                        v-if="journey.stopAtParking"
                                        class="text-green-500 font-medium">
                                        Kết thúc tại bãi
                                    </p>
                                    <p>
                                        Địa điểm kết thúc: {{ journey.stopAtLocation?.address }}
                                    </p>
                                </hts-tooltip>
                                <template
                                    v-for="(travel, index) in travelDetails"
                                    :key="index">
                                    <template v-if="travel.type === 'stage'">
                                        <hts-tooltip
                                            class="hts-journey-info-travel__stage"
                                            :alert="getAlert(travel)"
                                            placement="bottom"
                                            :class="{ 'no-before': !travel.eta, 'no-after': !travel.etd, 'has-alert': getAlert(travel) }"
                                            :style="getStageStyle(travel)">
                                            <template #reference>
                                                <div class="relative">
                                                    <div
                                                        class="relative inline-block w-full px-2 rounded bg-transparent text-center text-white whitespace-nowrap text-ellipsis overflow-hidden font-medium">
                                                        <div
                                                            v-if="travel.waitingTimeEstimate"
                                                            class="inline-block align-middle mr-1 rounded-full bg-white">
                                                            <hts-tooltip placement="top">
                                                                <template #reference>
                                                                    <hts-icons
                                                                        icon-name="hi-clock-icon"
                                                                        color="orange" />
                                                                </template>
                                                                <div>
                                                                    Thời gian chờ: {{ $formatters.duration(travel.waitingTimeEstimate, 's') }}
                                                                </div>
                                                            </hts-tooltip>
                                                        </div>
                                                        <span class="inline-block align-middle">
                                                            {{ travel.nodeName }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <p class="text-blue-500 font-medium">
                                                Điểm: {{ travel.nodeName }}
                                            </p>
                                            <p>
                                                ETA: {{ $formatters.datetime(travel.eta) }}
                                            </p>
                                            <p>
                                                ETD: {{ $formatters.datetime(travel.etd) }}
                                            </p>
                                            <template v-if="travel.nextPositionTravelDuration">
                                                <p>
                                                    Thời gian di chuyển tới điểm tiếp theo:
                                                </p>
                                                <p>
                                                    {{ $formatters.duration(travel.nextPositionTravelDuration, 's') }}
                                                </p>
                                            </template>
                                        </hts-tooltip>
                                    </template>
                                    <template v-else>
                                        <hts-tooltip
                                            class="hts-journey-info-travel__task"
                                            :alert="getAlert(travel)"
                                            :class="{ 'no-before': !travel.eta, 'no-after': !travel.etd, 'has-alert': getAlert(travel) }"
                                            reference-class="h-full"
                                            :style="getTaskStyle(travel)">
                                            <template #reference>
                                                <div class="h-full flex items-center px-2">
                                                    <div class="whitespace-nowrap text-ellipsis overflow-hidden text-white font-medium drop-shadow">
                                                        <div
                                                            v-if="travel.waitingTimeEstimate"
                                                            class="inline-block align-middle mr-1 rounded-full bg-white/70">
                                                            <hts-tooltip placement="top">
                                                                <template #reference>
                                                                    <hts-icons
                                                                        icon-name="hi-clock-icon"
                                                                        color="orange" />
                                                                </template>
                                                                <div>
                                                                    Thời gian chờ: {{ $formatters.duration(travel.waitingTimeEstimate, 's') }}
                                                                </div>
                                                            </hts-tooltip>
                                                        </div>
                                                        <span class="inline-block align-middle">
                                                            {{ travel.taskName }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <p class="text-green-500 font-medium">
                                                Tác vụ: {{ travel.taskName }}
                                            </p>
                                            <p>
                                                ETA: {{ $formatters.datetime(travel.eta) }}
                                            </p>
                                            <p>
                                                ETD: {{ $formatters.datetime(travel.etd) }}
                                            </p>
                                        </hts-tooltip>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <div class="relative py-1 hover:bg-gray-100">
                            <div
                                class="relative"
                                :style="{ height: config.unitHeight * 4 + 'px' }">
                                <template v-if="!exclude.includes('start')">
                                    <hts-tooltip
                                        v-if="journey.startAtActual"
                                        class="hts-journey-info-travel__start no-arrow"
                                        :style="getStartStyle(true)">
                                        <template #reference>
                                            <span>
                                                start
                                            </span>
                                        </template>
                                        <p class="text-blue-500 font-medium">
                                            Khởi hành: {{ journeyStartAtActual }}
                                        </p>
                                        <p
                                            v-if="journey.startAtParking"
                                            class="text-blue-500 font-medium">
                                            Khởi hành tại bãi
                                        </p>
                                        <p>
                                            Địa điểm khởi hành: {{ journey.startAtLocation?.address }}
                                        </p>
                                    </hts-tooltip>
                                </template>
                                <template v-if="!exclude.includes('stop')">
                                    <hts-tooltip
                                        v-if="journey.startAtActual && journey.stopAtActualEstimate"
                                        class="hts-journey-info-travel__stop no-arrow"
                                        :style="getStopStyle(true)">
                                        <template #reference>
                                            <span>
                                                stop
                                            </span>
                                        </template>
                                        <p class="text-blue-500 font-medium">
                                            Kết thúc: {{ journeyStopAtActual }}{{ journey.stopAtActual ? '' : '(Dự kiến)' }}
                                        </p>
                                        <p
                                            v-if="journey.stopAtParking"
                                            class="text-green-500 font-medium">
                                            Kết thúc tại bãi
                                        </p>
                                        <p>
                                            Địa điểm kết thúc: {{ journey.stopAtLocation?.address }}
                                        </p>
                                    </hts-tooltip>
                                </template>
                                <template
                                    v-for="(travel, index) in travelDetails"
                                    :key="index">
                                    <template v-if="travel.type === 'stage'">
                                        <hts-tooltip
                                            class="hts-journey-info-travel__stage"
                                            :alert="getAlert(travel)"
                                            :class="{ 'no-before': !travel.ata, 'no-after': !travel.atd, 'has-alert': getAlert(travel) }"
                                            :style="getStageStyle(travel, true)">
                                            <template #reference>
                                                <div class="relative">
                                                    <div
                                                        class="relative inline-block w-full px-2 rounded bg-transparent text-center text-white whitespace-nowrap text-ellipsis overflow-hidden font-medium">
                                                        <div
                                                            v-if="travel.waitingTime"
                                                            class="inline-block align-middle mr-1 rounded-full bg-white">
                                                            <hts-tooltip placement="top">
                                                                <template #reference>
                                                                    <hts-icons
                                                                        icon-name="hi-clock-icon"
                                                                        size="mini"
                                                                        color="orange" />
                                                                </template>
                                                                <div>
                                                                    Thời gian chờ: {{ $formatters.duration(travel.waitingTime, 's') }}
                                                                </div>
                                                            </hts-tooltip>
                                                        </div>
                                                        <span class="inline-block align-middle">
                                                            {{ travel.nodeName }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <p class="text-blue-500 font-medium">
                                                Điểm: {{ travel.nodeName }}
                                            </p>
                                            <p>
                                                <span>
                                                    ATA:&nbsp;
                                                </span>
                                                <span v-if="travel.ata">
                                                    {{ $formatters.datetime(travel.ata) }}
                                                </span>
                                                <span
                                                    v-else-if="travel.ataEstimate"
                                                    class="text-gray-500">
                                                    {{ $formatters.datetime(travel.ataEstimate) }} (Dự kiến)
                                                </span>
                                            </p>
                                            <p>
                                                <span>
                                                    ATD:&nbsp;
                                                </span>
                                                <span v-if="travel.atd">
                                                    {{ $formatters.datetime(travel.atd) }}
                                                </span>
                                                <span
                                                    v-else-if="travel.atdEstimate"
                                                    class="text-gray-500">
                                                    {{ $formatters.datetime(travel.atdEstimate) }} (Dự kiến)
                                                </span>
                                            </p>
                                            <template v-if="travel.nextPositionTravelDuration">
                                                <p>
                                                    Thời gian di chuyển tới điểm tiếp theo:
                                                </p>
                                                <p>
                                                    {{ $formatters.duration(travel.nextPositionTravelDuration, 's') }}
                                                </p>
                                            </template>
                                        </hts-tooltip>
                                    </template>
                                    <template v-else>
                                        <hts-tooltip
                                            class="hts-journey-info-travel__task"
                                            :alert="getAlert(travel)"
                                            :class="{ 'no-before': !travel.ata, 'no-after': !travel.atd, 'has-alert': getAlert(travel) }"
                                            reference-class="h-full"
                                            :style="getTaskStyle(travel, true)">
                                            <template #reference>
                                                <div class="h-full flex items-center px-2">
                                                    <div class="whitespace-nowrap text-ellipsis overflow-hidden text-white font-medium drop-shadow">
                                                        <div
                                                            v-if="travel.waitingTime"
                                                            class="inline-block align-middle mr-1 rounded-full bg-white/70">
                                                            <hts-tooltip placement="top">
                                                                <template #reference>
                                                                    <hts-icons
                                                                        icon-name="hi-clock-icon"
                                                                        color="orange" />
                                                                </template>
                                                                <div>
                                                                    Thời gian chờ: {{ $formatters.duration(travel.waitingTime, 's') }}
                                                                </div>
                                                            </hts-tooltip>
                                                        </div>
                                                        <span class="inline-block align-middle">
                                                            {{ travel.taskName }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <p class="text-green-500 font-medium">
                                                Tác vụ: {{ travel.taskName }}
                                            </p>
                                            <p>
                                                <span>
                                                    ATA:&nbsp;
                                                </span>
                                                <span v-if="travel.ata">
                                                    {{ $formatters.datetime(travel.ata) }}
                                                </span>
                                                <span
                                                    v-else-if="travel.ataEstimate"
                                                    class="text-gray-500">
                                                    {{ $formatters.datetime(travel.ataEstimate) }} (Dự kiến)
                                                </span>
                                            </p>
                                            <p>
                                                <span>
                                                    ATD:&nbsp;
                                                </span>
                                                <span v-if="travel.atd">
                                                    {{ $formatters.datetime(travel.atd) }}
                                                </span>
                                                <span
                                                    v-else-if="travel.atdEstimate"
                                                    class="text-gray-500">
                                                    {{ $formatters.datetime(travel.atdEstimate) }} (Dự kiến)
                                                </span>
                                            </p>
                                        </hts-tooltip>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div
                        class="hts-journey-info-travel__current"
                        :style="currentTimeStyle" />
                </div>
            </div>
        </template>
    </div>
</template>
<script lang="ts" setup>
// import AlertStatus from '../../monitoring/-components/alert-status.vue'
const { $dayjs, $formatters } = useNuxtApp()
const props = defineProps({
  journey: {
    type: Object,
    required: true
  },
  utcOffset: {
    type: Number as PropType<number>,
    default: 0
  },
  exclude: {
    type: Array as PropType<any[]>,
    default: () => []
  }
})
const loading = ref(true)
const { journey } = toRefs(props)
const { system } = $store()
const scaler = ref<string>('day')
const selectedDate = ref<any>(null)
const datetime = (s?: string | number) => {
  return $dayjs.tz(s, system.getWorkspaceTimezone)
}
const travelDetails = computed<any[]>(() => journey.value.travelDetails || [])
const minTime = computed<number>(() => {
  if (journey.value.startAtActual) {
    return Math.min(journey.value.startAt || 0, journey.value.startAtActual || 0)
  }
  return journey.value.startAt || 0
})
const stopAtEstimate = computed(() => journey.value.stopAtEstimate || journey.value.stopAt)
const maxTime = computed<number>(() => {
  if (journey.value.stopAtActual) {
    return Math.max(stopAtEstimate.value || 0, journey.value.stopAtActual || 0, journey.value.stopAtActualEstimate || 0)
  }
  return Math.max(journey.value.startAt || 0, stopAtEstimate.value || 0)
})
onMounted(() => {
  init()
})
watch(
  () => journey.value,
  (val: any) => {
    init()
  },
  { deep: true }
)

const startAt = ref<any>(null)
const stopAt = ref<any>(null)
const init = (scale: string = 'day') => {
  if (scale === 'month') {
    config.value.unitWidth = 80
  } else if (scale === 'day') {
    config.value.unitWidth = 120
  } else {
    config.value.unitWidth = 40
  }
  loading.value = true
  setTimeout(() => {
    let min: number = minTime.value
    let max: number = maxTime.value
    for (let i = 0; i < travelDetails.value.length; i++) {
      const { eta, etd, ata, ataEstimate, atd, atdEstimate } = travelDetails.value[i] as any
      if (eta) {
        if (!min) {
          min = eta
        }
        if (!max) {
          max = eta
        }
        min = Math.min(min, eta)
        max = Math.max(max, eta)
      }
      if (etd) {
        if (!min) {
          min = etd
        }
        if (!max) {
          max = etd
        }
        min = Math.min(min, etd)
        max = Math.max(max, etd)
      }
      if (ata) {
        if (!ata) {
          min = ata
        }
        if (!max) {
          max = ata
        }
        min = Math.min(min, ata)
        max = Math.max(max, ata)
      }
      if (atd) {
        if (!atd) {
          min = atd
        }
        if (!max) {
          max = atd
        }
        min = Math.min(min, atd)
        max = Math.max(max, atd)
      }
      if (ataEstimate) {
        if (!ataEstimate) {
          min = ataEstimate
        }
        if (!max) {
          max = ataEstimate
        }
        min = Math.min(min, ataEstimate)
        max = Math.max(max, ataEstimate)
      }
      if (atdEstimate) {
        if (!atdEstimate) {
          min = atdEstimate
        }
        if (!max) {
          max = atdEstimate
        }
        min = Math.min(min, atdEstimate)
        max = Math.max(max, atdEstimate)
      }
    }

    if (scale === 'day') {
      startAt.value = datetime(min).subtract(1, 'h').startOf('h')
      stopAt.value = datetime(max).add(1, 'h').endOf('h')
    }
    nextTick(() => {
      scaler.value = scale
      loading.value = false
    })
  }, 300)
}

const waitingTime = computed<any>(() => journey.value.totalWaitingTime)
const config = computed(() => {
  return {
    unitWidth: 120,
    unitHeight: 20
  }
})

const rangeUnits = computed(() => {
  if (scaler.value === 'hour') {
    return 60
  }
  if (scaler.value === 'month' && selectedDate.value) {
    const end = datetime(selectedDate.value).endOf('M')
    const start = datetime(selectedDate.value).startOf('M')
    return end.diff(start, 'd') + 1
  }
  return 24
})
const ranges = computed(() => {
  const result: any[] = []
  if (scaler.value === 'hour' && selectedDate.value) {
    return [
      {
        date: datetime(selectedDate.value).valueOf(),
        min: 0,
        label: datetime(selectedDate.value).format('DD/MM - HH')
      }
    ]
  } else if (scaler.value === 'month' && selectedDate.value) {
    return [
      {
        date: datetime(selectedDate.value).valueOf(),
        min: 0,
        label: datetime(selectedDate.value).format('MM/YYYY')
      }
    ]
  } else {
    scaler.value = 'day'
  }
  if (!startAt.value || !stopAt.value) {
    return []
  }
  const tmpMin = startAt.value
  const tmpMax = stopAt.value
  const hours = stopAt.value.endOf('D').diff(startAt.value.startOf('D'), 'h')
  const days = Math.ceil(hours / 24)
  for (let i = 0; i < days; i++) {
    let units = 24
    let min = 0
    if (i === 0) {
      units = 24 - tmpMin.hour()
      min = tmpMin.hour()
    } else if (i === days - 1 && days > 0) {
      units = tmpMax.hour()
    }
    result.push({
      date: tmpMin.add(i, 'd').valueOf(),
      label: tmpMin.add(i, 'd').format('DD/MM'),
      units,
      min
    })
  }
  return result
})
const timelineDiff = computed(() => stopAt.value.diff(startAt.value, scalerLeftUnit.value) + 1)
const timelineWidth = computed(() => timelineDiff.value * config.value.unitWidth)
const scalerLeftUnit = computed(() => {
  if (scaler.value === 'day') {
    return 'h'
  }
  if (scaler.value === 'hour') {
    return 'm'
  }
  return 'd'
})
const scalerWidthUnit = computed(() => {
  if (scaler.value === 'day') {
    return 'm'
  }
  if (scaler.value === 'hour') {
    return 's'
  }
  return 'h'
})
const scalerWidthUnitValue = computed(() => (scaler.value === 'month' ? 24 : 60))
const getStageStyle = (data: any, actual: boolean = false) => {
  const { eta, etd, ata, ataEstimate, atd, atdEstimate, index } = data
  let tmpA = eta
  if (actual) {
    tmpA = ata || ataEstimate
  }
  let tmpD = etd
  if (actual) {
    tmpD = atd || atdEstimate
  }
  if (!tmpA && !tmpD) {
    return {
      display: 'none'
    }
  }
  let offset = 0
  if (!tmpA) {
    tmpA = tmpD
    offset = 1
  }
  const tmpLeft = datetime(tmpA).subtract(offset, scalerLeftUnit.value).diff(startAt.value, scalerWidthUnit.value)
  let tmpWidth = tmpD ? datetime(tmpD).diff(datetime(tmpA), scalerWidthUnit.value) : 1
  if (tmpWidth < 1) {
    tmpWidth = 30
  }
  return {
    top: 0,
    width: Math.floor(tmpWidth * (config.value.unitWidth / scalerWidthUnitValue.value)) + 'px',
    height: config.value.unitHeight * 4 + 'px',
    left: Math.floor(tmpLeft * (config.value.unitWidth / scalerWidthUnitValue.value)) + 'px',
    zIndex: (index + 1) * 10
  }
}

const getTaskStyle = (data: any, actual: boolean = false) => {
  const { eta, etd, ata, ataEstimate, atd, atdEstimate, stageIndex } = data
  let tmpA = eta
  if (actual) {
    tmpA = ata || ataEstimate
  }
  let tmpD = etd
  if (actual) {
    tmpD = atd || atdEstimate
  }
  if (!tmpA && !tmpD) {
    return {
      display: 'none'
    }
  }
  let offset = 0
  if (!tmpA) {
    tmpA = tmpD
    offset = 1
  }
  const tmpLeft = datetime(tmpA).subtract(offset, scalerLeftUnit.value).diff(startAt.value, scalerWidthUnit.value)
  let tmpWidth = tmpD ? datetime(tmpD).diff(datetime(tmpA), scalerWidthUnit.value) : 1
  if (tmpWidth < 1) {
    tmpWidth = 1
  }

  return {
    width: Math.floor(tmpWidth * (config.value.unitWidth / scalerWidthUnitValue.value)) + 'px',
    height: config.value.unitHeight * 1.5 + 'px',
    top: config.value.unitHeight * 1.3 + 'px',
    left: Math.floor(tmpLeft * (config.value.unitWidth / scalerWidthUnitValue.value)) + 'px',
    zIndex: (stageIndex + 1) * 20
  }
}

const journeyStartAt = computed(() => {
  return $formatters.datetime(journey.value.startAt)
})
const journeyStartAtActualValue = computed(() => journey.value.startAtActual || journey.value.startAtEstimate)
const journeyStartAtActual = computed(() => {
  return $formatters.datetime(journeyStartAtActualValue.value)
})
const journeyStopAt = computed(() => {
  return $formatters.datetime(stopAtEstimate.value)
})
const journeyStopAtActualValue = computed(() => journey.value.stopAtActual || journey.value.stopAtActualEstimate)
const journeyStopAtActual = computed(() => {
  return $formatters.datetime(journeyStopAtActualValue.value)
})
const getStartStyle = (actual: boolean = false) => {
  let time = journey.value.startAt
  if (actual) {
    time = journeyStartAtActualValue.value
  }
  const tmpLeft = datetime(time).diff(startAt.value, scalerWidthUnit.value)
  return {
    display: time ? undefined : 'none',
    left: Math.floor(tmpLeft * (config.value.unitWidth / scalerWidthUnitValue.value)) + 'px'
  }
}

const getStopStyle = (actual: boolean = false) => {
  const time = stopAtEstimate.value
  if (actual) {
    const tmpLeft = datetime(journeyStopAtActualValue.value).diff(startAt.value, scalerWidthUnit.value)
    return {
      display: journeyStopAtActualValue.value ? undefined : 'none',
      left: Math.floor(tmpLeft * (config.value.unitWidth / scalerWidthUnitValue.value)) + 'px'
    }
  }
  const tmpLeft = datetime(time).diff(startAt.value, scalerWidthUnit.value)
  return {
    display: time ? undefined : 'none',
    left: Math.floor(tmpLeft * (config.value.unitWidth / scalerWidthUnitValue.value)) + 'px'
  }
}

const currentTimeStyle = reactive({
  left: 0
})

onMounted(() => {
  setCurrentTime()
  setInterval(setCurrentTime, 1000)
})

const setCurrentTime = () => {
  if (loading.value) {
    return
  }
  const now = datetime()
  const tmpLeft = datetime(now).diff(startAt.value, scalerWidthUnit.value)
  const visible = now.diff(startAt.value, 'm') > 0 && now.diff(stopAt.value, 'm') <= 0
  Object.assign(currentTimeStyle, {
    display: visible ? undefined : 'none',
    left: Math.floor(tmpLeft * (config.value.unitWidth / scalerWidthUnitValue.value)) + 'px'
  })
}
const setScaler = (day: any, scale: string, hour?: number) => {
  if (!['day', 'month'].includes(scale)) {
    return
  }
  if (scaler.value === scale) {
    return
  }
  const { date } = day
  if (!date) {
    return
  }
  selectedDate.value = date
  if (scale === 'month') {
    startAt.value = datetime(selectedDate.value).startOf('M').startOf('D')
    stopAt.value = datetime(selectedDate.value).endOf('M').endOf('D')
    config.value.unitWidth = 80
  }
  init(scale)
}
const setSubScaler = (day: any, scale: string, hour?: number) => {
  if (!['day', 'hour'].includes(scale)) {
    return
  }
  if (scaler.value === scale) {
    return
  }
  const { date } = day
  if (!date) {
    return
  }
  selectedDate.value = date
  if (scale === 'hour' && hour !== undefined) {
    selectedDate.value = datetime(date).hour(hour).valueOf()
    startAt.value = datetime(date).hour(hour).startOf('h')
    stopAt.value = datetime(date).hour(hour).endOf('h')
  }
  init(scale)
}

const getAlert = (travel: any) => {
  const { ata, processAlertStatus } = travel
  if (ata) {
    return null
  }
  if (Number.isNaN(processAlertStatus)) {
    return null
  }
  if (processAlertStatus >= 30) {
    return 'red'
  }
  if (processAlertStatus >= 10) {
    return 'yellow'
  }
}
</script>
